import { ErrorFallback } from '@components/ErrorFallback/ErrorFallback';
import { ErrorBoundary } from 'react-error-boundary';
import { RenderElement } from 'types/components';

const GlobalErrorBoundary = ({ children }: { children: RenderElement }) => (
  <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
);

export default GlobalErrorBoundary;
